import { render, staticRenderFns } from "./Reinstatement.vue?vue&type=template&id=6c5a56e8"
import script from "./Reinstatement.vue?vue&type=script&lang=js"
export * from "./Reinstatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports